<template>
  <div id="micro-dashboard">
    <h1>Global Number = {{ globalNumber }}</h1>
    <div 
    v-for="v in vueApps" 
    class="list-item"
    :key="v.name">
      <VueContainer 
      :vueApp="v" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueContainer from './components/VueContainer.vue'
import EventBus from './data/event-bus.js'

export default {
  name: 'micro-dashboard',
  components: {
    VueContainer
  },
  data () {
    return {
      vueApps: [
        {
          name: 'number-display',
          type: 'Vue',
          path: 'http://vue.crowflats.com/vue-apps/number-display/'
        },
        {
          name: 'number-edit',
          type: 'Vue',
          path: 'http://vue.crowflats.com/vue-apps/number-edit/'
        }
      ],
      globalNumber: 0
    }
  },
  methods: {
  },
  mounted() {
    window.addEventListener('update:global-number', e => {
      this.globalNumber = e.detail;
    });
  }
}
</script>

<style>
#micro-dashboard {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
